import authHeader from "./auth-header";
import axiosInstance from "./instance";

class RdmService {
  getRdmAllUsers() {
    return axiosInstance.get("/rdm_users/", {
      headers: authHeader(),
    });
  }

  refreshRdmAllUsers() {
    return axiosInstance.get("/refresh_rdm_users/", {
      headers: authHeader(),
    });
  }

  getRdmUserShips(id) {
    return axiosInstance.get("/user_ships", {
      params: { id },
      headers: authHeader(),
    });
  }

  getRdmOwnerShips(params) {
    return axiosInstance.get("/owner_ships/", {
      params: {
        maintainer: params.maintainer,
        owner_id: params.ownerId,
      },
      headers: authHeader(),
    });
  }

  refreshOwners() {
    return axiosInstance.get("/refresh_owners", {
      headers: authHeader(),
    });
  }

  getRdmNewUser() {
    return axiosInstance.get("/new_user", {
      headers: authHeader(),
    });
  }

  createRdmUser(rdmNewUserData) {
    return axiosInstance.post(
      "/create_user",
      {
        userData: rdmNewUserData.userData,
        userShips: rdmNewUserData.userShips,
        removeShips: rdmNewUserData.removeShips,
      },
      { headers: authHeader() }
    );
  }

  updateRdmUser(rdmUpdateUserData) {
    return axiosInstance.put(
      "/update_user",
      {
        userData: rdmUpdateUserData.userData,
        userShips: rdmUpdateUserData.userShips,
        removeShips: rdmUpdateUserData.removeShips,
      },
      { headers: authHeader() }
    );
  }

  updateRdmUserShips(rdmUpdateUserShips) {
    return axiosInstance.put(
      "/update_ships",
      {
        userData: rdmUpdateUserShips.userData,
        userShips: rdmUpdateUserShips.userShips,
        removeShips: rdmUpdateUserShips.removeShips,
      },
      { headers: authHeader() }
    );
  }

  deleteRdmUser(id) {
    return axiosInstance.put(
      "/delete_rdm_user",
      {},
      { params: { id }, headers: authHeader() }
    );
  }
  triggerRecovery(params) {
    return axiosInstance.post("/rdm_recovery_trigger", params, {
      headers: authHeader(),
    });
  }
}

export default new RdmService();
